import Header from './components/Header';
import Footer from './components/Footer';
import Top from './components/Top';
import Home from './pages/Home';

const App = () => {
  return (
    <div>
      <Header />
      <Top />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
